const hasSmoothScroll = 'scrollBehavior' in document.documentElement.style;

const scrollToOptions = hasSmoothScroll
  ? ({
      top: 0,
      left: 0,
      behavior: 'smooth',
    } as ScrollToOptions)
  : undefined;

const scrollIntoViewOptions = hasSmoothScroll
  ? ({
      behavior: 'smooth',
      block: 'start',
    } as ScrollIntoViewOptions)
  : false;

export const scrollToTop = () => {
  window.scrollTo(scrollToOptions);
};

export const scrollToElement = (element: HTMLElement) => {
  if (!hasSmoothScroll) {
    return;
  }
  element.scrollIntoView(scrollIntoViewOptions);
};



// WEBPACK FOOTER //
// ./src/services/scrolling.ts